import React from 'react';
import { Img } from 'react-image';
import { PrepPlanBadgeStatus } from 'types';

type Props = {
	day: number;
	status: PrepPlanBadgeStatus;
};
const PrepareDayBadge = ({ day, status }: Props) => {
	const statusImage = {
		[PrepPlanBadgeStatus.LOCKED]: '/assets/prepPlanLocked.svg',
		[PrepPlanBadgeStatus.IN_PROGRESS]: '/assets/prepPlanCompleted.svg',
		[PrepPlanBadgeStatus.COMPLETED]: '/assets/prepPlanCompleted.svg',
	};
	return (
		<div className="flex justify-center md:justify-start">
			<div className="rounded-[36px] w-max dark:bg-[#CCDDFF] bg-[#7777E7] flex items-center justify-center gap-x-2 px-[23px] py-1">
				<Img src={statusImage[status]} className="w-[20px] h-[20px]" />
				<span className="dark:text-[#18222D] text-[#FFFFFF] text-lg font-medium">{`Day ${day}`}</span>
			</div>
		</div>
	);
};

export default PrepareDayBadge;
